import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuthBootstrap } from "./AuthBootstrapContext";

const API_BASE = "https://api-2026.fikacreatives.co";

const NotificationsContext = createContext(null);

export function NotificationsProvider({ children }) {
  const { person } = useAuthBootstrap();
  const personId = person?.id;

  const [hasBadge, setHasBadge] = useState(false);
  const [fikaData, setFikaData] = useState(null);
  const [fikaLoading, setFikaLoading] = useState(true);

  const check = useCallback(async () => {
    if (!personId) return;
    try {
      setFikaLoading(true);
      const res = await fetch(`${API_BASE}/api/fikas?personId=${personId}`, {
        credentials: "include",
      });
      if (!res.ok) return;
      const data = await res.json();
      setFikaData(data);

      // Badge condition 1: active cycle exists but user hasn't responded yet
      const cycleResponsePending = !!data.nextCycleId && data.mySlots === null;

      // Badge condition 2: user has a pending coffee invite they haven't accepted
      const now = Date.now();
      const hasPendingCoffeeInvite = (data.coffeeInvites ?? []).some(
        (inv) => inv.role === "invitee" && !inv.acceptedAt && new Date(inv.expiresAt).getTime() > now
      );

      setHasBadge(cycleResponsePending || hasPendingCoffeeInvite);
    } catch {} finally {
      setFikaLoading(false);
    }
  }, [personId]);

  useEffect(() => {
    check();
  }, [check]);

  function markAvailabilitySubmitted() {
    setHasBadge(false);
  }

  return (
    <NotificationsContext.Provider value={{
      availabilityPending: hasBadge,
      markAvailabilitySubmitted,
      refreshNotifications: check,
      fikaData,
      fikaLoading,
    }}>
      {children}
    </NotificationsContext.Provider>
  );
}

export function useNotifications() {
  const ctx = useContext(NotificationsContext);
  if (!ctx) throw new Error("useNotifications must be used within NotificationsProvider");
  return ctx;
}
